import { HsaFsaInlineLogo } from '@jouzen/ecom-components/icons/HsaFsaInlineLogo';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useFeatureGate } from '@statsig/react-bindings';

import RichText from '@/app/components/RichText';

const LogoComponent = () => (
  <HsaFsaInlineLogo className="inline-block -translate-y-px" color="white" />
);

const HsaFsaIcon = () => {
  const isUS = useFeatureGate('usa_only').value;

  if (isUS) {
    return (
      <div
        className="flex flex-row items-center justify-center"
        data-cy="hsa-fsa-icon"
      >
        <Typography className="text-white" weight="bold">
          <RichText
            messageKey="hsa_fsa_eligible_line_item"
            tValues={{
              logo: LogoComponent,
            }}
          />
        </Typography>
      </div>
    );
  } else {
    return <></>;
  }
};

export default HsaFsaIcon;
